// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Contenedor principal */
.MinimumSaleTable_container__H0sRj {
  width: 100%;
}

/* Paper wrapper */
.MinimumSaleTable_paper__zOI9H {
  overflow-x: auto;
  border-radius: 8px;
}

/* Tabla */
.MinimumSaleTable_table__UuJ\\+9 {
  min-width: 650px;
}

/* ============================= */
/*            HEADER             */
/* ============================= */

.MinimumSaleTable_tableHeadRow__H8RTG {
  background-color: #357c8c;
}

/* Todos los th dentro del header */
.MinimumSaleTable_tableHeadRow__H8RTG th {
  color: #ffffff;
  font-weight: 700;
  text-align: center;
  width: 12.5%;
}

/* ============================= */
/*             BODY              */
/* ============================= */

.MinimumSaleTable_tableBodyRow__XBqpS {
  border-bottom: 1px solid #f0f0f0;
}

/* Todas las celdas del body */
.MinimumSaleTable_tableBodyRow__XBqpS td {
  text-align: center;
}

/* Celdas destacadas */
.MinimumSaleTable_bold__Xybg4 {
  font-weight: 700;
}

/* Mensaje vacío */
.MinimumSaleTable_emptyMessage__gWyfg {
  color: #888888;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Several/MinimumSales/MinimumSaleTable.module.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC,kCAAkC;AAClC,kCAAkC;;AAElC;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA,kCAAkC;AAClC,kCAAkC;AAClC,kCAAkC;;AAElC;EACE,gCAAgC;AAClC;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,kBAAkB;AACpB","sourcesContent":["/* Contenedor principal */\n.container {\n  width: 100%;\n}\n\n/* Paper wrapper */\n.paper {\n  overflow-x: auto;\n  border-radius: 8px;\n}\n\n/* Tabla */\n.table {\n  min-width: 650px;\n}\n\n/* ============================= */\n/*            HEADER             */\n/* ============================= */\n\n.tableHeadRow {\n  background-color: #357c8c;\n}\n\n/* Todos los th dentro del header */\n.tableHeadRow th {\n  color: #ffffff;\n  font-weight: 700;\n  text-align: center;\n  width: 12.5%;\n}\n\n/* ============================= */\n/*             BODY              */\n/* ============================= */\n\n.tableBodyRow {\n  border-bottom: 1px solid #f0f0f0;\n}\n\n/* Todas las celdas del body */\n.tableBodyRow td {\n  text-align: center;\n}\n\n/* Celdas destacadas */\n.bold {\n  font-weight: 700;\n}\n\n/* Mensaje vacío */\n.emptyMessage {\n  color: #888888;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MinimumSaleTable_container__H0sRj`,
	"paper": `MinimumSaleTable_paper__zOI9H`,
	"table": `MinimumSaleTable_table__UuJ+9`,
	"tableHeadRow": `MinimumSaleTable_tableHeadRow__H8RTG`,
	"tableBodyRow": `MinimumSaleTable_tableBodyRow__XBqpS`,
	"bold": `MinimumSaleTable_bold__Xybg4`,
	"emptyMessage": `MinimumSaleTable_emptyMessage__gWyfg`
};
export default ___CSS_LOADER_EXPORT___;
